/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

import _Popconfirm from './popconfirm.js';
import mapProps from '../utils/map-props.js';
import { withInstall } from '../utils/withInstall.js';
import './style/css.js';
import './type.js';
import '../_chunks/dep-9d6f3de6.js';
import '@babel/runtime/helpers/defineProperty';
import 'tdesign-icons-vue';
import '../utils/mixins.js';
import 'vue';
import '../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';
import '../popup/index.js';
import '../popup/popup.js';
import '@babel/runtime/helpers/typeof';
import '@popperjs/core';
import '../utils/dom.js';
import 'raf';
import 'lodash/isString';
import '../utils/easing.js';
import '../utils/render-tnode.js';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import '../_common/js/utils/set-style.js';
import '../popup/props.js';
import '../popup/container.js';
import '../popup/type.js';
import './props.js';
import '../utils/event.js';
import '../dialog/actions.js';
import 'lodash/isObject';
import '../button/index.js';
import '../button/button.js';
import '../loading/index.js';
import '../loading/loading.js';
import '../loading/icon/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '../utils/transfer-dom.js';
import '../loading/props.js';
import '../loading/type.js';
import '../loading/plugin.js';
import '../config.js';
import 'lodash/capitalize';
import '../button/props.js';
import '../utils/ripple.js';
import '../button/type.js';

var Popconfirm = withInstall(mapProps(["visible"], {
  model: {
    prop: "visible",
    event: "visible-change"
  }
})(_Popconfirm));

export { Popconfirm, Popconfirm as default };
//# sourceMappingURL=index.js.map
